const countries = [
    "🇺🇸 United States",
    "🇬🇧 United Kingdom",
    "🇦🇪 United Arab Emirates",
    "🇨🇦 Canada",
    "🇩🇪 Germany",
    "🇫🇷 France",
    "🇮🇳 India",
    "🇦🇺 Australia",
    "🇸🇬 Singapore",
    "🇳🇱 Netherlands",
];

export default function TrustedBy() {
    return (
        <section className="relative py-20 px-6 overflow-hidden">

            {/* subtle top fade to blend with hero */}
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/20 pointer-events-none" />

            <div className="relative max-w-7xl mx-auto">

                {/* Heading */}
                <div className="text-center mb-10">
                    <p className="text-gray-400 uppercase tracking-[0.25em] text-sm">
                        SERVING CLIENTS WORLDWIDE · PRICING IN <b>£</b>GBP & <b>$</b>USD
                    </p>
                </div>

                {/* Countries */}
                <div className="relative overflow-hidden">

                    {/* Left fade */}
                    <div className="absolute left-0 top-0 w-24 h-full bg-gradient-to-r from-[#020617] to-transparent z-10" />

                    {/* Right fade */}
                    <div className="absolute right-0 top-0 w-24 h-full bg-gradient-to-l from-[#020617] to-transparent z-10" />

                    <div className="flex gap-4 animate-scroll whitespace-nowrap">

                        {[...countries, ...countries].map((country, index) => (
                            <div
                                key={index}
                                className="
                  px-6 py-3
                  rounded-full
                  border border-white/10
                  bg-white/[0.03]
                  backdrop-blur-md
                  text-gray-300
                  hover:text-cyan-400
                  hover:border-cyan-400/30
                  transition-all
                  duration-300
                  flex-shrink-0
                "
                            >
                                {country}
                            </div>
                        ))}

                    </div>
                </div>
            </div>
        </section>
    );
}